import React from 'react';
     import '/vercel/path0/docs/guide/write-demo.md?watch=parent';
export const demos = {
  'docs-guide-write-demo-demo-0': {
    component: React.memo(React.lazy(async function() {
  /**
 * defaultShowCode: true
 */ const { default: React } = await import('react');
return {
    default: ()=>/*#__PURE__*/ React.createElement("h1", null, "Hello dumi!")
};

})),
    asset: {
  "type": "BLOCK",
  "id": "docs-guide-write-demo-demo-0",
  "refAtomIds": [],
  "dependencies": {
    "index.jsx": {
      "type": "FILE",
      "value": "import React from 'react';\n\nexport default () => <h1>Hello dumi!</h1>;"
    },
    "react": {
      "type": "NPM",
      "value": "18.3.1"
    }
  },
  "entry": "index.jsx"
},
    context: {
  "react": require('react')
},
    renderOpts: {
          
          compile: async (...args) => {
            return (await import('/vercel/path0/dist/client/misc/reactDemoCompiler.js')).default(...args);
          },
        },
  },
  'docs-guide-write-demo-demo-cols': {
    component: React.memo(React.lazy(() => import( /* webpackChunkName: "demos" */ '/vercel/path0/docs/guide/demos/cols.tsx?techStack=react'))),
    asset: {
  "type": "BLOCK",
  "id": "docs-guide-write-demo-demo-cols",
  "refAtomIds": [],
  "dependencies": {
    "index.tsx": {
      "type": "FILE",
      "value": require('/vercel/path0/docs/guide/demos/cols.tsx?dumi-raw').default
    },
    "react": {
      "type": "NPM",
      "value": "18.3.1"
    }
  },
  "entry": "index.tsx"
},
    context: {
  "react": require('react')
},
    renderOpts: {
          
          compile: async (...args) => {
            return (await import('/vercel/path0/dist/client/misc/reactDemoCompiler.js')).default(...args);
          },
        },
  },
  'docs-guide-write-demo-demo-1': {
    component: React.memo(React.lazy(async function() {
  /**
 * transform: true
 * defaultShowCode: true
 */ /**
 * transform: true
 */ const { default: React } = await import('react');
return {
    default: ()=>/*#__PURE__*/ React.createElement("h1", {
            style: {
                position: 'fixed',
                top: 0,
                left: 0
            }
        }, "我不会飞出去")
};

})),
    asset: {
  "type": "BLOCK",
  "id": "docs-guide-write-demo-demo-1",
  "refAtomIds": [],
  "dependencies": {
    "index.jsx": {
      "type": "FILE",
      "value": "/**\n * transform: true\n */\n\nimport React from 'react';\n\nexport default () => (\n  <h1 style={{ position: 'fixed', top: 0, left: 0 }}>我不会飞出去</h1>\n);"
    },
    "react": {
      "type": "NPM",
      "value": "18.3.1"
    }
  },
  "entry": "index.jsx"
},
    context: {
  "react": require('react')
},
    renderOpts: {
          
          compile: async (...args) => {
            return (await import('/vercel/path0/dist/client/misc/reactDemoCompiler.js')).default(...args);
          },
        },
  },
  'docs-guide-write-demo-demo-2': {
    component: React.memo(React.lazy(async function() {
  /**
 * background: '#f6f7f9'
 * defaultShowCode: true
 */ /**
 * background: '#f6f7f9'
 */ const { default: React } = await import('react');
return {
    default: ()=>null
};

})),
    asset: {
  "type": "BLOCK",
  "id": "docs-guide-write-demo-demo-2",
  "refAtomIds": [],
  "dependencies": {
    "index.jsx": {
      "type": "FILE",
      "value": "/**\n * background: '#f6f7f9'\n */\n\nimport React from 'react';\n\nexport default () => null;"
    },
    "react": {
      "type": "NPM",
      "value": "18.3.1"
    }
  },
  "entry": "index.jsx"
},
    context: {
  "react": require('react')
},
    renderOpts: {
          
          compile: async (...args) => {
            return (await import('/vercel/path0/dist/client/misc/reactDemoCompiler.js')).default(...args);
          },
        },
  },
  'docs-guide-write-demo-demo-3': {
    component: React.memo(React.lazy(async function() {
  /**
 * compact: true
 * defaultShowCode: true
 */ /**
 * compact: true
 */ const { default: React } = await import('react');
return {
    default: ()=>'我会贴边站'
};

})),
    asset: {
  "type": "BLOCK",
  "id": "docs-guide-write-demo-demo-3",
  "refAtomIds": [],
  "dependencies": {
    "index.jsx": {
      "type": "FILE",
      "value": "/**\n * compact: true\n */\n\nimport React from 'react';\n\nexport default () => '我会贴边站';"
    },
    "react": {
      "type": "NPM",
      "value": "18.3.1"
    }
  },
  "entry": "index.jsx"
},
    context: {
  "react": require('react')
},
    renderOpts: {
          
          compile: async (...args) => {
            return (await import('/vercel/path0/dist/client/misc/reactDemoCompiler.js')).default(...args);
          },
        },
  },
  'docs-guide-write-demo-demo-4': {
    component: React.memo(React.lazy(async function() {
  /**
 * title: 我是标题
 * description: 我是简介，我可以用 `Markdown` 来编写
 * defaultShowCode: true
 */ /**
 * title: 我是标题
 * description: 我是简介，我可以用 `Markdown` 来编写
 */ const { default: React } = await import('react');
return {
    default: ()=>null
};

})),
    asset: {
  "type": "BLOCK",
  "id": "docs-guide-write-demo-demo-4",
  "refAtomIds": [],
  "dependencies": {
    "index.jsx": {
      "type": "FILE",
      "value": "/**\n * title: 我是标题\n * description: 我是简介，我可以用 `Markdown` 来编写\n */\n\nimport React from 'react';\n\nexport default () => null;"
    },
    "react": {
      "type": "NPM",
      "value": "18.3.1"
    }
  },
  "entry": "index.jsx",
  "description": "我是简介，我可以用 Markdown 来编写",
  "title": "我是标题"
},
    context: {
  "react": require('react')
},
    renderOpts: {
          
          compile: async (...args) => {
            return (await import('/vercel/path0/dist/client/misc/reactDemoCompiler.js')).default(...args);
          },
        },
  },
  'docs-guide-write-demo-demo-5': {
    component: React.memo(React.lazy(async function() {
  /**
 * inline: true
 */ const { default: React } = await import('react');
return {
    default: ()=>/*#__PURE__*/ React.createElement("p", null, "我会被直接嵌入")
};

})),
    asset: null,
    context: undefined,
    renderOpts: undefined,
  },
  'docs-guide-write-demo-demo-6': {
    component: React.memo(React.lazy(async function() {
  /**
 * inline: true
 */ const { default: React } = await import('react');
const { default: Previewer } = await import('dumi/theme/builtins/Previewer');
return {
    default: ()=>/*#__PURE__*/ React.createElement(Previewer, {
            asset: {
                id: 'docs-guide-write-demo-demo-6',
                dependencies: {
                    'index.tsx': {
                        type: 'FILE',
                        value: "/**\n * debug: true\n */\n\nimport React from 'react';\n\nexport default () => '我仅在开发环境下展示';"
                    }
                }
            },
            demoUrl: "",
            disabledActions: [
                'EXTERNAL'
            ],
            defaultShowCode: true,
            debug: true
        }, "我仅在开发环境下展示")
};

})),
    asset: null,
    context: undefined,
    renderOpts: undefined,
  },
  'docs-guide-write-demo-demo-7': {
    component: React.memo(React.lazy(async function() {
  /**
 * iframe: true
 * compact: true
 * defaultShowCode: true
 */ /**
 * iframe: true
 * compact: true
 */ const { default: React } = await import('react');
return {
    default: ()=>/*#__PURE__*/ React.createElement("h2", {
            style: {
                boxShadow: '0 2px 15px rgba(0,0,0,0.1)',
                padding: '5px 20px',
                margin: 0
            }
        }, "iframe 模式")
};

})),
    asset: {
  "type": "BLOCK",
  "id": "docs-guide-write-demo-demo-7",
  "refAtomIds": [],
  "dependencies": {
    "index.jsx": {
      "type": "FILE",
      "value": "/**\n * iframe: true\n * compact: true\n */\nimport React from 'react';\n\nexport default () => (\n  <h2\n    style={{\n      boxShadow: '0 2px 15px rgba(0,0,0,0.1)',\n      padding: '5px 20px',\n      margin: 0,\n    }}\n  >\n    iframe 模式\n  </h2>\n);"
    },
    "react": {
      "type": "NPM",
      "value": "18.3.1"
    }
  },
  "entry": "index.jsx"
},
    context: {
  "react": require('react')
},
    renderOpts: {
          
          compile: async (...args) => {
            return (await import('/vercel/path0/dist/client/misc/reactDemoCompiler.js')).default(...args);
          },
        },
  },
};